import React from "react";
import { NavLink } from "react-router-dom";
import { runtimeConfig } from "src/services/runtimeConfig";
import styles from "./AdvancedRemediationNav.module.css";

interface Props {
  phoneNumber?: string;
}

const NAV_ITEMS = [
  { to: "/sysadmin/ad-hoc-dialer", label: "Ad Hoc Dialer" },
  {
    to: `${runtimeConfig.coreUrl}/app/sysadmin/trustcalllookup`,
    label: "TrustCall Lookup",
    external: true,
  },
  { to: "/sysadmin/tnrm-scan", label: "TNRM Reputation Scan" },
  { to: "/sysadmin/hiya-scan", label: "Hiya Reputation Scan" },
];

const AdvancedRemediationNav: React.FC<Props> = ({ phoneNumber }) => {
  const buildTo = (basePath: string) => {
    if (!phoneNumber) return basePath;
    return `${basePath}/${encodeURIComponent(phoneNumber)}`;
  };

  return (
    <div className={styles.navContainer}>
      <div className={styles.navHeader}>Advanced Remediation Tools</div>
      <nav className={styles.nav}>
        {NAV_ITEMS.map((item) =>
          item.external ? (
            <a
              key={item.to}
              href={phoneNumber ? `${item.to}?phone=${encodeURIComponent(phoneNumber)}` : item.to /* external TrustCall Lookup expects ?phone= */}
              className={styles.navLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              {item.label}
              <span className={styles.externalIcon}>&#8599;</span>
            </a>
          ) : (
            <NavLink
              key={item.to}
              to={buildTo(item.to)}
              className={({ isActive }) =>
                `${styles.navLink} ${isActive ? styles.active : ""}`
              }
            >
              {item.label}
            </NavLink>
          ),
        )}
      </nav>
    </div>
  );
};

export default AdvancedRemediationNav;
